export default {
  SET_LOADING (state, obj) {
    state.callingAPI = obj.flag
    state.callingAPIMessage = obj.message
  },
  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  }
}
